<template>
    <div>
        <b-modal id="create-hr" :title="report.Id ? 'Düzenle' : 'Ekle'" no-close-on-esc no-close-on-backdrop>
            <health-report-create v-model="report"></health-report-create>
            <template #modal-footer><v-executer :loading="loading" :action="upload">Kaydet</v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    :settings="false"
                    :items-provider="provider"
                    :add-callback="createNew"></v-table>
    </div>
</template>

<script>
import HealthReportCreate from './components/HealthReportCreate.vue'
import HealthReportApi from '@/api/health-report'
import Additional from '@/utilities/additional'

export default{
    components:{
        HealthReportCreate
    },
    props:{
        id:[String,Number],
    },
    data(){
        return {
            fields:[
                {name:'Başlangıç Tarihi',key:'StartDateStr',thClass:''},
                // {name:'Bitiş Tarihi',key:'EndDateStr',thClass:''},
                {name:'Takip Gerektiren Durum',key:'SurveillanceRequired',thClass:''},
                {name:'Takip Gerekçesi',key:'HealthReportSurveillanceReasonName',thClass:''},
                {name:'Takip Sıklığı',key:'SurveillanceFrequencyStr',thClass:''},
                {name:'Yüksekte Çalışmaya Uygundur',key:'CanWorkAtHeights',thClass:''},
                {name:'Gece Vardiyasında Çalışabilir',key:'CanWorkAtNightShift',thClass:''},
                {name:'Doktor Onayı',key:'DoctorApproval',thClass:''},
                {name:'Sağlık Onayı Açıklaması',key:'HealthApprovalDescription',thClass:''},
                {name:'Engelli',key:'DisabledPerson',thClass:''},
                {name:'Engellilik Oranı',key:'DisabilityRate',thClass:''}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                { text:"Engellilik Belgesi İndir",key:"download",icon:"DownloadIcon",variant:"success",action:this.downloadD, condition:item => item.DisabilityFilePath },
                { text:"Sağlık Raporu İndir",key:"download",icon:"DownloadIcon",variant:"success",action:this.downloadH, condition:item => item.HealthReportFilePath }
            ],
            loading:false,
            report:{
                Id:null,
                EmployeeId:this.id,
                StartDate:null,
                EndDate:null,
                DisabledPerson:false,
                DisabilityRate:null,
                SurveillanceRequired:false,
                HealthReportSurveillanceReasonId:null,
                DisabilityFile:null,
                HealthReportFile:null,
                SurveillanceFrequency:null,
                SurveillanceFrequencyUnit:null,
                CanWorkAtHeights:false,
                CanWorkAtNightShift:false,
                DoctorApproval:false,
                HealthApprovalDescription:null
            }
        }
    },
    methods:{
        clearForm(){
            this.report.Id = null
            this.report.StartDate = null
            this.report.EndDate = null
            this.report.SurveillanceRequired = false
            this.report.HealthReportSurveillanceReasonId = null
            this.report.DisabilityFile = null
            this.report.DisabledPerson = false
            this.report.DisabilityRate = null
            this.report.HealthReportFile = null
            this.report.SurveillanceFrequency = null
            this.report.SurveillanceFrequencyUnit = null
            this.report.CanWorkAtHeights = false
            this.report.CanWorkAtNightShift = false
            this.report.DoctorApproval = false
            this.report.HealthApprovalDescription = null
        },
        edit(item){
            this.clearForm()
            this.report.Id = item.Id
            this.report.StartDate = item.StartDate
            // this.report.EndDate = item.EndDate
            this.report.DisabledPerson = item.DisabledPerson
            this.report.DisabilityRate = item.DisabilityRate
            this.report.SurveillanceRequired = item.SurveillanceRequired
            this.report.HealthReportSurveillanceReasonId = item.HealthReportSurveillanceReasonId
            this.report.SurveillanceFrequency = item.SurveillanceFrequency
            this.report.SurveillanceFrequencyUnit = item.SurveillanceFrequencyUnit
            this.report.CanWorkAtHeights = item.CanWorkAtHeights
            this.report.CanWorkAtNightShift = item.CanWorkAtNightShift
            this.report.DoctorApproval = item.DoctorApproval
            this.report.HealthApprovalDescription = item.HealthApprovalDescription
            this.report.HealthReportFile = item.HealthReportFilePath
            this.report.DisabilityFile = item.DisabilityFilePath
            this.$showModal('create-hr')
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-hr')
        },
        provider(data){
            return HealthReportApi.Employee.Table({
                ...data,
                EmployeeId:this.id
            })
        },
        upload(){
            const formData = new FormData()
            if(this.report.Id) formData.append('Id', this.report.Id)
            formData.append('EmployeeId',this.id)
            if(this.report.StartDate != null) formData.append('StartDate',this.report.StartDate)
            // if(this.report.EndDate != null) formData.append('EndDate',this.report.EndDate)
            
            if(this.report.HealthReportFile != null && typeof this.report.HealthReportFile === 'object') {
                formData.append('HealthReportFile',this.report.HealthReportFile)
            }
            
            if(this.report.SurveillanceRequired != null) formData.append('SurveillanceRequired',this.report.SurveillanceRequired)
            if(this.report.SurveillanceRequired){
                if(this.report.HealthReportSurveillanceReasonId != null) formData.append('HealthReportSurveillanceReasonId',this.report.HealthReportSurveillanceReasonId)
                if(this.report.SurveillanceFrequency != null) formData.append('SurveillanceFrequency',this.report.SurveillanceFrequency)
                if(this.report.SurveillanceFrequencyUnit != null) formData.append('SurveillanceFrequencyUnit',this.report.SurveillanceFrequencyUnit)
            }
            if(this.report.DisabledPerson != null) formData.append('DisabledPerson',this.report.DisabledPerson)
            if(this.report.DisabledPerson){
                if(this.report.DisabilityRate != null) formData.append('DisabilityRate',this.report.DisabilityRate)
                if(this.report.DisabilityFile != null && typeof this.report.DisabilityFile === 'object') {
                    formData.append('DisabilityFile',this.report.DisabilityFile)
                }
            }
            if(this.report.CanWorkAtHeights != null) formData.append('CanWorkAtHeights',this.report.CanWorkAtHeights)
            if(this.report.CanWorkAtNightShift != null) formData.append('CanWorkAtNightShift',this.report.CanWorkAtNightShift)
            if(this.report.DoctorApproval != null) formData.append('DoctorApproval',this.report.DoctorApproval)
            if(this.report.HealthApprovalDescription != null) formData.append('HealthApprovalDescription',this.report.HealthApprovalDescription)

            this.loading = true
            const request = this.report.Id
                ? HealthReportApi.Employee.Update(formData)
                : HealthReportApi.Employee.Create(formData)
            
            request.then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-hr')
                }
                this.$result(res)
                this.loading = false
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem sağlık raporunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HealthReportApi.Employee.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        downloadH(item){
            Additional.DownloadTab(item.HealthReportFilePath)
        },
        downloadD(item){
            Additional.DownloadTab(item.DisabilityFilePath)
        }
    }
}
</script>